import { render, staticRenderFns } from "./Basis.vue?vue&type=template&id=0c664e7e&scoped=true&"
import script from "./Basis.vue?vue&type=script&lang=js&"
export * from "./Basis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c664e7e",
  null
  
)

export default component.exports